<template>
	<button class="btn btn--color" @click="showPopup = !showPopup">Добавить управляющего категорией</button>

	<transition name="modal">
		<AddCategoryAdminPopup :productGroups="productGroups" v-if="showPopup" @close="showPopup = false" />
	</transition>

</template>
<script>

import AddCategoryAdminPopup from "@/components/sections/CategoryAdmins/AddCategoryAdminPopup.vue";

export default {
	name: "ManagersAdd",
	components: {AddCategoryAdminPopup},
	props: {
		productGroups: {
			type: Object,
			default: () => {}
		}
	},
	data() {
		return {
			showPopup: false
		}
	}
}
</script>


